t = require('views/internal/teacup-with-helpers')('calendar_month')

module.exports = ->
  t.table '.calendar-table'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/calendar_month.coffee